import { Provider } from '@angular/core';
import { provideFilterOptionLoaders } from '@shared/dataview/options/filter-options.registry';
import { OccOptionsLoader } from '@shared/dataview/options/loaders/occ.loader';
import { PayorPlanTypesOptionsLoader } from '@shared/dataview/options/loaders/payor-plan-types.loader';
import { PharmacyChainsOptionsLoader } from '@shared/dataview/options/loaders/pharmacy-chains.loader';
import { PharmacyFamiliesOptionsLoader } from '@shared/dataview/options/loaders/pharmacy-families.loader';
import { ProductNdcsOptionsLoader } from '@shared/dataview/options/loaders/products.loader';
import { ProgramGroupsOptionsLoader } from '@shared/dataview/options/loaders/program-groups.loader';
import { StatesOptionsLoader } from '@shared/dataview/options/loaders/states.loader';
import { TenantsOptionsLoader, TenantsWithUnassignedOptionsLoader } from '@shared/dataview/options/loaders/tenants.loader';

export function provideDataViewFilterOptions(): Provider[] {
  return provideFilterOptionLoaders(
    OccOptionsLoader,
    PayorPlanTypesOptionsLoader,
    PharmacyChainsOptionsLoader,
    PharmacyFamiliesOptionsLoader,
    ProductNdcsOptionsLoader,
    ProgramGroupsOptionsLoader,
    StatesOptionsLoader,
    TenantsOptionsLoader,
    TenantsWithUnassignedOptionsLoader,
  );
}
